import {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useMatch} from 'react-router-dom';
import {twMerge} from 'tailwind-merge';

import VerticalSeparator from 'App/components/separator/veticalSeparator';
import {selectFeatureFlag} from 'App/features/featureFlags/featureFlagsSlice';
import {selectUserCredentials} from 'App/features/user/userSlice';
import NavButton from 'App/layout/components/navButton';
import Controls from 'Pages/app/header/controls';
import HomeButton from 'Pages/app/header/home_button';

const Nav = (): ReactElement => {
  const {t} = useTranslation();
  const credentials = useSelector(selectUserCredentials);
  const isRedesignAvailable = useSelector(
    selectFeatureFlag('isRedesignAvailable'),
  );

  // Default route / NavButton should be highlighted also for /search page
  const match = useMatch('/search');
  const isSearchPage = Boolean(match);

  const {
    show_crm: shouldShowCampaigns,
    show_crmcampaign,
    show_land_layer,
    show_pages: shouldShowPages,
    show_project_revenue,
  } = credentials?.organization || {};

  const shouldShowLand =
    !shouldShowCampaigns && !show_crmcampaign && show_land_layer;

  return (
    <div
      className={twMerge(
        'relative flex items-center px-[8px]',
        isRedesignAvailable
          ? 'h-[50px] bg-white shadow-[0px_8px_23px_0px_rgba(101,122,163,0.17)]'
          : 'h-[40px] bg-green-500',
      )}
    >
      <HomeButton />
      {isRedesignAvailable && <VerticalSeparator />}
      <div
        className={twMerge(
          'flex gap-x-3',
          isRedesignAvailable ? 'ml-3' : 'ml-2.5',
        )}
      >
        <NavButton
          to="/projects"
          text={t('Develop my projects')}
          icon="icon-projects"
        />
        <NavButton
          to="/home"
          text={t('Assess an address')}
          icon="icon-land"
          isMatch={isSearchPage}
        />
        {shouldShowLand && (
          <NavButton
            to="/land"
            text={t('Search for my lands')}
            icon="icon-campaigns"
          />
        )}
        {shouldShowCampaigns && (
          <NavButton
            to="/campaigns"
            text={
              show_project_revenue
                ? t('Prospect a city')
                : 'Rechercher des terrains'
            }
            icon="icon-campaigns"
            dataTest="campaigns"
          />
        )}
        {shouldShowPages && (
          <NavButton
            to="/pages"
            text={t('Look at a projects page')}
            icon="icon-pages"
          />
        )}
      </div>
      <div className="ml-auto">
        <Controls />
      </div>
    </div>
  );
};

export default Nav;
